// @ts-nocheck
/* eslint-disable */

import React, { useEffect, useState } from 'react';
import NoSsr from '@/components/NoSsr/NoSsr';
import { BannerName } from '@/components/Banners/Banners.types';
import { AdManagerBanners } from '@/components/Banners/Banners.constants';
import { useBridgeState } from '@/bridge/hooks';

export interface Props {
  bannerName: BannerName;
}

export const AdManagerBanner = ({ bannerName }: Props) => {
  const { isWebView } = useBridgeState();

  useEffect(() => {
    if (typeof window === 'undefined' || isWebView) return;

    const googletag = window.googletag || (window.googletag = { cmd: [] });

    googletag.cmd.push(() => {
      const bannerConfig = AdManagerBanners[bannerName];

      const existingSlots = googletag.pubads().getSlots();
      const existingSlot = existingSlots.find(
        slot => slot.getSlotElementId() === bannerConfig.blockId
      );

      if (existingSlot) {
        googletag.destroySlots([existingSlot]);
      }

      const slot = googletag.defineSlot(
        bannerConfig.bannerId,
        bannerConfig.sizes,
        bannerConfig.blockId
      );

      if (slot) {
        slot.addService(googletag.pubads());
        googletag.enableServices();
      }
    });

    setTimeout(() => {
      googletag.cmd.push(() => {
        googletag.display(AdManagerBanners[bannerName].blockId);
      });
    }, 0);
  }, [bannerName]);

  return (
    <NoSsr>
      <div
        className={AdManagerBanners[bannerName].blockId}
        id={AdManagerBanners[bannerName].blockId}
      />
    </NoSsr>
  );
};
